import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import GenericFormItem from '../GenericFormItem';

const TypeQuantity = function TypeQuantity(props) {
  const {
    val,
    label,
    form,
  } = props;

  const getItemLabel = (item) => {
    const choice = _.find(form.choices, { key: item.key });
    return choice.label;
  };

  const mappedVal = val.map(item => (
    <div className="uk-grid uk-grid-divider" key={item.key}>
      <div className="uk-width-medium-3-5 uk-width-mobile-3-4">
        {getItemLabel(item)}
      </div>
      <div className="uk-width-medium-2-5 uk-width-mobile-1-4">
        {item.quantity}
      </div>
    </div>
  ));
  return (
    <GenericFormItem label={label}>
      {mappedVal}
    </GenericFormItem>
  );
};

TypeQuantity.propTypes = {
  val: PropTypes.arrayOf(PropTypes.any),
  label: PropTypes.string,
  form: PropTypes.objectOf(PropTypes.any),
};

export default TypeQuantity;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/TypeQuantity.js